import BaseModel from "./base/baseModel";

export default class ConvenioClinicaModel extends BaseModel {
    id?: number = null;
    convenioId?: number = null;
    clinicaId?: number = null;
    clinicaNome?: string = null;
}
